import api from "./api";

export const getDashboardReport = async (params) => {
  const { data } = await api.get("/dashboard/report", { params });
  return data;
};

export const listFunnelStageNames = async () => {
  const { data } = await api.get("/dashboard/funnelStageNames");
  return data;
};

export const getDashboardContactReport = async (params) => {
  const { data } = await api.get("/dashboard/contactReport", { params });
  return data;
};
